import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { IBiomarker } from '../../entities/Biomarker/Biomarker';

export class BiomarkerApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Biomarkers`;

    public static apiUrls = {
        getBiomarkers: `${BiomarkerApi.baseApiUrl}`,
    };

    public static async getBiomarkers(): Promise<IBiomarker[]> {
        return this.sendApiRequest<IBiomarker[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getBiomarkers,
        });
    }
} 